export const Pages = {
    ESTADISTICAS_FANTASY_JUGADORES: 'ESTADISTICAS_FANTASY_JUGADORES',
    LIDERES_ESTADISTICAS: 'LIDERES_ESTADISTICAS',
    INICIO: 'INICIO',
    MERCADO: 'MERCADO',
    ANALIZA_TU_PLANTILLA: 'ANALIZA_TU_PLANTILLA',
    NOTICIA: 'NOTICIA',
    NOTICIAS: 'NOTICIAS',
    JUGADOR: 'JUGADOR',
    COMPARADOR_DE_JUGADORES: 'COMPARADOR_DE_JUGADORES',
    LESIONADOS_SANCIONADOS_APERCIBIDOS: 'LESIONADOS_SANCIONADOS_APERCIBIDOS',
    CLASIFICACION: 'CLASIFICACION',
    ONCE_IDEAL: 'ONCE_IDEAL',
    LANZADORES_PENALTIS: 'LANZADORES_PENALTIS',
    ESTADISTICAS_DEL_JUGADOR: 'ESTADISTICAS_DEL_JUGADOR',
    ESTADISTICAS_DEL_JUGADOR_DEFAULT: 'ESTADISTICAS_DEL_JUGADOR_DEFAULT',
    LIDERES_POR_JORNADAS: 'LIDERES_POR_JORNADAS',
    MEJORES_RACHAS: 'MEJORES_RACHAS',
    INICIA_SESION: 'INICIA_SESION',
    REGISTRATE: 'REGISTRATE',
    MIS_PLANTILLAS: 'MIS_PLANTILLAS',
    EDITAR_PLANTILLA: 'EDITAR_PLANTILLA',
    CREAR_PLANTILLA: 'CREAR_PLANTILLA',
    PLANTILLAS_PUBLICAS: 'PLANTILLAS_PUBLICAS',
    TERMINOS_CONDICIONES: 'TERMINOS_CONDICIONES',
    OLVIDASTE_TU_CONTRASENA: 'OLVIDASTE_TU_CONTRASENA',
    POLITICAS_PRIVACIDAD: 'POLITICAS_PRIVACIDAD',
    CONTACTANOS: 'CONTACTANOS',
    PARTIDO: 'PARTIDO',
    CALENDARIO_FANTASY: 'CALENDARIO_FANTASY',
    EQUIPO: 'EQUIPO',
    REESTABLECER_CONTRASENA: 'REESTABLECER_CONTRASENA',
    ANALISIS_PLANTILLA: 'ANALISIS_PLANTILLA',
    ENCUESTA_DE_SATISFACCION: 'ENCUESTA_DE_SATISFACCION',
    PERFIL_DE_USUARIO: 'PERFIL_DE_USUARIO',
    ALINEACIONES_PROBABLES: 'ALINEACIONES_PROBABLES',
    FANTASY_MANAGER: 'FANTASY_MANAGER',
    PREDICTING_MANAGER: 'PREDICTING_MANAGER',
    PREDICTING_MANAGER_RANKING: 'PREDICTING_MANAGER_RANKING',
    ADMINISTRADOR_JUGADORES: 'ADMINISTRADOR_JUGADORES',
    PREDICTING_MANAGER_ALINEACIONES: 'PREDICTING_MANAGER_ALINEACIONES',
    PREDICTING_MANAGER_RULES: 'PREDICTING_MANAGER_RULES',
    COLABORADORES: 'COLABORADORES',
    COLABORADORES_NOTICIAS: 'COLABORADORES_NOTICIAS',
    PARTE_MEDICO: 'PARTE_MEDICO',
    JUGADORES: 'JUGADORES',
    JUGADOR: 'JUGADOR',
    QUINIELA_CLASIFICACION: 'QUINIELA_CLASIFICACION',
    QUINIELA_REGLAS_DEL_JUEGO: 'QUINIELA_REGLAS_DEL_JUEGO',
    ADMINISTRADOR_QUINIELA: 'ADMINISTRADOR_QUINIELA',
    QUINIELA_REGLAS_DEL_JUEGO: 'QUINIELA_REGLAS_DEL_JUEGO',
    QUINIELA_CLASIFICACION: 'QUINIELA_CLASIFICACION',
    QUINIELA_JUEGO: 'QUINIELA_JUEGO',
    PUJA_FANTASY: 'PUJA_FANTASY',
    PUJA_FANTASY_BIWENGER: 'PUJA_FANTASY_BIWENGER',
    JUGADORES_SANCIONADOS: ' JUGADORES_SANCIONADOS',
    JUGADORES_LESIONADOS: 'JUGADORES_LESIONADOS',
    JUGADORES_DUDAS: 'JUGADORES_DUDAS',
    JUGADORES_APERCIBIDOS: 'JUGADORES_APERCIBIDOS',
    NOTICIAS_FLASH: 'NOTICIAS_FLASH',
    MERCADO_FICHAJES: 'MERCADO_FICHAJES',
    NOTICIAS_FLASH_ADMIN: 'NOTICIAS_FLASH_ADMIN',
    HISTORIAS: 'HISTORIAS',
    HISTORIAS_CREAR: 'HISTORIAS_CREAR',
    HISTORIAS_EDITAR: 'HISTORIAS_EDITAR',
    CALENDARIO_COMPETICIONES: 'CALENDARIO_COMPETICIONES',
    ADMINISTRADOR_CONVOCATORIAS: 'ADMINISTRADOR_CONVOCATORIAS',
    CONVOCATORIAS: 'CONVOCATORIAS',
    VIRUS_FIFA: 'VIRUS_FIFA',
    APUESTAS_DEPORTIVAS: 'APUESTAS_DEPORTIVAS',
    MERCADO_BIWENGER: 'MERCADO_BIWENGER',
    MERCADO_BIWENGER_TABLE: 'MERCADO_BIWENGER_TABLE',
    ESTADISTICAS_BIWENGER: 'ESTADISTICAS_BIWENGER',
    CHAT: 'CHAT',
    REGLAS_CHAT: 'REGLAS_CHAT',
    INSTALL_APP: 'INSTALL_APP',
    PREMIOS_Y_SORTEOS: 'PREMIOS_Y_SORTEOS',
    ACTIVIDADES: 'ACTIVIDADES',
    SALON_DE_LA_FAMA: 'SALON_DE_LA_FAMA',
    CHOLLOS_FANTASY_BIWENGER: 'CHOLLOS_FANTASY_BIWENGER',
    CHOLLOS_FANTASY_RELEVO: 'CHOLLOS_FANTASY_RELEVO',
    CHOLLOS_FANTASY_MARCA: 'CHOLLOS_FANTASY_MARCA',
    ONCE_TIPO: 'ONCE_TIPO',
    QUEDADA_FANTASY: 'QUEDADA_FANTASY',
    CALENDARIO_ADMIN: 'CALENDARIO_ADMIN',
    COMPARTIR_PLANTILLA: 'COMPARTIR_PLANTILLA',
    ADMINISTRADOR_PARTIDOS: 'ADMINISTRADOR_PARTIDOS',
    TIER_LIST: 'TIER_LIST',
    TIER_LIST_PUBLIC: 'TIER_LIST_PUBLIC',
    EDIT_TIER_LIST: 'EDIT_TIER_LIST',
    NUEVA_TIER_LIST: 'NUEVA_TIER_LIST',
    VISUALIZAR_TIER_LIST: 'VISUALIZAR_TIER_LIST',
    DELETE_TIER_LIST: 'DELETE_TIER_LIST',
    FANTASY_DAZN_FALLECIO: 'FANTASY_DAZN_FALLECIO',
    ADMINISTRADOR_CONFIGURACIONES: 'ADMINISTRADOR_CONFIGURACIONES',
    ORACULO_FANTASY: 'ORACULO_FANTASY',
    KIT_DIGITAL: 'KIT_DIGITAL',
    SITIOS_RECOMENDADOS: 'SITIOS_RECOMENDADOS',
    SUSCRIPCIONES: 'SUSCRIPCIONES',
    PAGO_EXITOSO: 'PAGO_EXITOSO',
    PAGO_CANCELADO: 'PAGO_CANCELADO',
    CREADORES_CONTENIDO: 'CREADORES_CONTENIDO',
    PUNTUACIONES_FANTASY: 'PUNTUACIONES_FANTASY',
    PREPARADOR_JORNADA: 'PREPARADOR_JORNADA',
    MERCADO_EQUIPOS: 'MERCADO_EQUIPOS',
    NOVEDADES: 'NOVEDADES',
    PREMIUM: 'PREMIUM',
    PREMIUM_ANALYSIS: 'PREMIUM_ANALYSIS',
    PREMIUM_ACTIVIDADES: 'PREMIUM_ACTIVIDADES',
    ANALISIS_POST_PARTIDO: 'ANALISIS_POST_PARTIDO',
    JUGADORES_BIWENGER: 'JUGADORES_BIWENGER',
    ACTA_ARBITRAL_PARTIDO: 'ACTA_ARBITRAL_PARTIDO',
    SALDO_ARBITRAL_PARTIDOS: 'SALDO_ARBITRAL_PARTIDOS',
    SALDO_ARBITRAL_PARTIDOS_ROJAS: 'SALDO_ARBITRAL_PARTIDOS_ROJAS',
    CENTRO_INFORMACION: 'CENTRO_INFORMACION',
    CENTRO_INFORMACION_FEED: 'CENTRO_INFORMACION_FEED',
    EQUIPOS_V2_NOTICIAS: 'EQUIPOS_V2_NOTICIAS',
    EQUIPOS_V2_CALENDARIO: 'EQUIPOS_V2_CALENDARIO',
    EQUIPOS_V2_DATOS: 'EQUIPOS_V2_DATOS',
    EQUIPOS_V2_ALINEACIONES: 'EQUIPOS_V2_ALINEACIONES',
    CALENDARIO_DE_PARTIDOS: 'CALENDARIO_DE_PARTIDOS',
    BUSCADOR_DE_JUGADORES: 'BUSCADOR_DE_JUGADORES',
    GUIAS_FANTASY: 'GUIAS_FANTASY',
    GUIAS_FANTASY_FANTASY_LA_LIGA: 'GUIAS_FANTASY_FANTASY_LA_LIGA',
    GUIAS_FANTASY_FANTASY_BIWENGER: 'GUIAS_FANTASY_FANTASY_BIWENGER',
    GUIAS_FANTASY_FANTASY_MARCA: 'GUIAS_FANTASY_FANTASY_MARCA',
    GUIAS_FANTASY_FANTASY_MISTER: 'GUIAS_FANTASY_FANTASY_MISTER',
    PREDICCION_PARTIDO: 'PREDICCION_PARTIDO',
    ONCE_TIPO: 'ONCE_TIPO',
    FICHAJES: 'FICHAJES',
    MERCADO_DAZN: 'MERCADO_DAZN',
    FICHAJES_EQUIPO: 'FICHAJES_EQUIPO',
    ESTADISTICAS_EQUIPO: 'ESTADISTICAS_EQUIPO',
    FANTASY_MARCA_MERCADO: 'FANTASY_MARCA_MERCADO',
    FANTASY_MARCA_MERCADO_EQUIPOS: 'FANTASY_MARCA_MERCADO_EQUIPOS',
    FANTASY_MARCA_SUBIDAS_Y_BAJADAS: 'FANTASY_MARCA_SUBIDAS_Y_BAJADAS',
    FANTASY_KAOS_PIZARRA: 'FANTASY_KAOS_PIZARRA',
    FANTASY_KAOS_PRESIDENTES: 'FANTASY_KAOS_PRESIDENTES',
    FANTASY_KAOS_REGLAS: 'FANTASY_KAOS_REGLAS',
    FANTASY_KAOS_MANAGERS: 'FANTASY_KAOS_MANAGERS',
    FANTASY_KAOS_RANKING_DE_PRESIDENTES: 'FANTASY_KAOS_RANKING_DE_PRESIDENTES',
    FANTASY_KAOS_SORTEO: 'FANTASY_KAOS_SORTEO',
    PREDICCION_DE_MERCADO: 'PREDICCION_DE_MERCADO',
    CHOLLOS_FANTASY_MISTER: 'CHOLLOS_FANTASY_MISTER',
    MISTER_FANTASY_MERCADO: 'MISTER_FANTASY_MERCADO',
    MISTER_FANTASY_MERCADO_EQUIPOS: 'MISTER_FANTASY_MERCADO_EQUIPOS',
    MISTER_FANTASY_SUBIDAS_Y_BAJADAS: 'MISTER_FANTASY_SUBIDAS_Y_BAJADAS',
    RULETA_FANTASY: 'RULETA_FANTASY',
    RULETA_FANTASY_RANKING: 'RULETA_FANTASY_RANKING',
    RULETA_FANTASY_RANKING_GLOBAL: 'RULETA_FANTASY_RANKING_GLOBAL',
    BUZON_CIUDADANO: 'BUZON_CIUDADANO',
    PUNTUACIONES_BIWENGER_DIARIO_AS: 'PUNTUACIONES_BIWENGER_DIARIO_AS',
    PUNTUACIONES_BIWENGER_SOFASCORE: 'PUNTUACIONES_BIWENGER_SOFASCORE',
    PUNTUACIONES_BIWENGER_STATS: 'PUNTUACIONES_BIWENGER_STATS',
    PUNTUACIONES_BIWENGER_SOCIAL: 'PUNTUACIONES_BIWENGER_SOCIAL',
    PUNTUACIONES_BIWENGER_CARRUSEL_DEPORTIVO: 'PUNTUACIONES_BIWENGER_CARRUSEL_DEPORTIVO',
    PUNTUACIONES_BIWENGER_PROMEDIO_DIARIO_AS_SOFASCORE: 'PUNTUACIONES_BIWENGER_PROMEDIO_DIARIO_AS_SOFASCORE',
    PUNTUACIONES_FANTASY_MARCA: 'PUNTUACIONES_FANTASY_MARCA',
    PUNTUACIONES_FANTASY_MISTER: 'PUNTUACIONES_FANTASY_MISTER',
    ESTADISTICAS_FANTASY_MARCA: 'ESTADISTICAS_FANTASY_MARCA',
    ESTADISTICAS_MISTER_FANTASY: 'ESTADISTICAS_MISTER_FANTASY',
    FAVORITOS: 'FAVORITOS',
    FAVORITOS_NOTICIAS: 'FAVORITOS_NOTICIAS',
    FAVORITOS_NOTICIAS_FLASH: 'FAVORITOS_NOTICIAS_FLASH',
    FAVORITOS_FANTASY_INFO: 'FAVORITOS_FANTASY_INFO',
    FAVORITOS_MISTER_FANTASY: 'FAVORITOS_MISTER_FANTASY',
    FAVORITOS_FANTASY_MARCA: 'FAVORITOS_FANTASY_MARCA',
    FAVORITOS_BIWENGER_DIARIO_AS: 'FAVORITOS_BIWENGER_DIARIO_AS',
    FAVORITOS_BIWENGER_SOFASCORE: 'FAVORITOS_BIWENGER_SOFASCORE',
    FAVORITOS_BIWENGER_ESTADISTICAS: 'FAVORITOS_BIWENGER_ESTADISTICAS',
    FAVORITOS_BIWENGER_DIARIO_AS_SOFASCORE: 'FAVORITOS_BIWENGER_DIARIO_AS_SOFASCORE',
    FAVORITOS_BIWENGER_SOCIAL: 'FAVORITOS_BIWENGER_SOCIAL',
    LOGS: 'LOGS',
    PREDICCIONES_FANTASY: 'PREDICCIONES_FANTASY',
    PREDICCIONES_FANTASY_RANKING: 'PREDICCIONES_FANTASY_RANKING',
    PREDICCIONES_FANTASY_REGLAS: 'PREDICCIONES_FANTASY_REGLAS',
    RECOMENDACIONES: 'RECOMENDACIONES',
    RECOMENDACIONES_CREAR: 'RECOMENDACIONES_CREAR',
    RECOMENDACIONES_EDITAR: 'RECOMENDACIONES_EDITAR',
    RECOMENDACIONES_VER: 'RECOMENDACIONES_VER',
    RECOMENDACIONES_ELIMINAR: 'RECOMENDACIONES_ELIMINAR',
    RECOMENDACIONES_PUBLICAS: 'RECOMENDACIONES_PUBLICAS',
    RECOMENDACIONES_VISUALIZAR: 'RECOMENDACIONES_VISUALIZAR',
    PRISMA_TERMINOS_Y_CONDICIONES: 'PRISMA_TERMINOS_Y_CONDICIONES',
    PRISMA_POLITICA_DE_PRIVACIDAD: 'PRISMA_POLITICA_DE_PRIVACIDAD',
    PRISMA_CONTACTO: 'PRISMA_CONTACTO',
    SOPORTE: 'SOPORTE',
    ALINEACIONES_PROBABLES_EDITORES: 'ALINEACIONES_PROBABLES_EDITORES',
    EDITORES_COMENTARIOS: 'EDITORES_COMENTARIOS',
    EDITORES_TOP_STAR: 'EDITORES_TOP_STAR',
    EDITORES_TOP_STAR_CREAR: 'EDITORES_TOP_STAR_CREAR',
    EDITORES_TOP_STAR_EDITAR: 'EDITORES_TOP_STAR_EDITAR',
    POSTS: 'POSTS',
    POST_CREAR: 'POST_CREAR',
    POST_EDITAR: 'POST_EDITAR',
    TOP_STAR_RECOMENDACIONES_JORNADA: 'TOP_STAR_RECOMENDACIONES_JORNADA',
};

export const Rutas = {
    ESTADISTICAS_FANTASY_JUGADORES: '/fantasy-la-liga/estadisticas',
    MERCADO: '/fantasy-la-liga/mercado',
    MERCADO_DAZN: '/fantasy-la-liga/mercado-fantasy-la-liga-dazn',
    MERCADO_EQUIPOS: '/fantasy-la-liga/mercado-equipos',
    CALENDARIO_FANTASY: '/fantasy-la-liga/calendario',
    ADMIN: '/administrador/fantasy',
    CONFIGURATION: '/configuracion',
    ANALIZA_TU_PLANTILLA: '/fantasy-la-liga/analisis-plantilla',
    LIDERES_ESTADISTICAS: '/fantasy-la-liga/jugadores-lideres-estadisticas',
    COMPARADOR_DE_JUGADORES: '/fantasy-la-liga/comparador-de-jugadores',
    CLASIFICACION: '/clasificacion',
    ESTADISTICAS_DEL_JUGADOR: '/jugadores',
    MEJORES_RACHAS: '/mejores-rachas/la-liga-fantasy',
    INICIA_SESION: '/iniciar-sesion',
    REGISTRATE: '/crear-cuenta',
    MIS_PLANTILLAS: '/mis-plantillas-fantasy',
    EDITAR_PLANTILLA: '/mis-plantillas-fantasy/editar-plantilla',
    GESTIONAR_PLANTILLA: (id) => `/mis-plantillas-fantasy/gestionar/${id}`,
    CREAR_PLANTILLA: '/mis-plantillas-fantasy/crear-plantilla',
    PLANTILLAS_PUBLICAS: '/plantillas-publicas',
    PLANTILLA_PUBLICA: (id) => `/plantilla-publica/${id}`,
    TERMINOS_CONDICIONES: '/terminos-y-condiciones',
    POLITICAS_PRIVACIDAD: '/politicas-de-privacidad',
    CONTACTANOS: '/contactanos',
    PARTIDO: '/partido',
    INICIO: '/',
    REESTABLECER_CONTRASENA: '/reestablecer-contrasena',
    PLANTILLA: '/fantasy-la-liga/analisis-plantilla',
    ENCUESTA_DE_SATISFACCION: '/encuesta-de-satisfaccion',
    PERFIL_DE_USUARIO: '/perfil-de-usuario',
    OLVIDASTE_TU_CONTRASENA: '/olvidaste-tu-contrasena',
    ALINEACIONES_PROBABLES: '/la-liga/alineaciones-probables',
    PREDICTING_MANAGER: '/predicting-manager/crear-alineaciones-probables',
    PREDICTING_MANAGER_RANKING: '/predicting-manager/clasificacion',
    ADMINISTRADOR_JUGADORES: '/administrador/jugadores',
    ADMINISTRADOR_IMAGENES: '/administrador/imagenes',
    BUSCADOR_JUGADORES: '/administrador/buscador',
    ADMIN_ALINEACIONES_PROBABLES: '/administrador/admin-alineaciones-probables',
    ALINEACIONES_PROBABLES_EDITORES: '/editores/alineaciones-probables',
    EDITORES_PREVIA_PARTIDO: '/editores/previa-partido',
    EDITORES_COMENTARIOS: '/editores/comentarios',
    EDITORES_TOP_STAR: '/editores/top-star',
    EDITORES_TOP_STAR_CREAR: '/editores/top-star/crear',
    EDITORES_TOP_STAR_EDITAR: (slug) => `/editores/top-star/editar/${slug}`,
    TOP_STAR_RECOMENDACIONES_JORNADA: '/top-star-recomendaciones',
    TOP_STAR_RECOMENDACIONES: (slug) => `/top-star-recomendaciones/${slug}`,
    PARTE_MEDICO: '/administrador/parte-medico',
    FANTASY_MANAGER: '/fantasy-manager',
    PREDICTING_MANAGER_ALINEACIONES: '/predicting-manager/alineaciones-de-managers',
    PREDICTING_MANAGER_RULES: '/predicting-manager/reglas-del-juego',
    NOTICIAS: '/noticias',
    CREADORES_DE_CONTENIDO: '/creador-de-contenido',
    ASESORIAS_FANTASY: '/asesorias-fantasy',
    FLASHSCORE: 'https://www.flashscore.es/',
    EQUIPO: '/equipo',
    COLABORADORES: '/colaboradores',
    COLABORADORES_NOTICIAS: '/colaboradores',
    JUGADORES: '/jugadores',
    ADMINISTRADOR_QUINIELA: '/administrador/quiniela-analitica',
    QUINIELA_REGLAS_DEL_JUEGO: '/quiniela-analitica/reglas-del-juego',
    QUINIELA_CLASIFICACION: '/quiniela-analitica/clasificacion',
    QUINIELA_JUEGO: '/quiniela-analitica/votaciones',
    PUJA_FANTASY: '/fantasy-la-liga/puja-ideal',
    PUJA_FANTASY_BIWENGER: '/biwenger/puja-ideal',
    JUGADORES_SANCIONADOS: '/la-liga/jugadores-sancionados',
    JUGADORES_LESIONADOS: '/la-liga/jugadores-lesionados',
    JUGADORES_DUDAS: '/la-liga/jugadores-dudas',
    JUGADORES_APERCIBIDOS: '/la-liga/jugadores-apercibidos',
    RECOMENDACIONES: '/recomendaciones',
    NOTICIAS_FLASH: '/noticias-flash',
    MERCADO_FICHAJES: '/mercado-fichajes',
    NOTICIAS_FLASH_ADMIN: '/administrador/noticias-flash-admin',
    HISTORIAS: '/historias',
    HISTORIAS_CREAR: '/historias/crear',
    HISTORIAS_EDITAR: '/historias/editar',
    CALENDARIO_COMPETICIONES: '/la-liga/calendario-competiciones',
    CONFIGURATION: '/administrador/configuracion',
    ADMINISTRADOR_CONVOCATORIAS: '/administrador/convocatorias',
    CONVOCATORIAS: '/convocatorias',
    VIRUS_FIFA: '/selecciones/convocatorias-jugadores/virus-fifa',
    APUESTAS_DEPORTIVAS: '/apuestas-deportivas',
    APUESTAS_DEPORTIVAS_FEED: '/apuestas-deportivas/feed',
    MERCADO_FICHAJES_EN_VIVO:
        '/noticias/mercado-de-fichajes-de-invierno-de-la-liga-en-vivo-2024-01-10-10-00-49',
    MERCADO_BIWENGER: '/biwenger/mercado',
    ESTADISTICAS_BIWENGER: '/biwenger/estadisticas',
    ACCOUNTS: '/administrador/accounts',
    BESOCCER: '/administrador/besoccer',
    INSTALL_APP: '/instala-la-app',
    PREMIOS_Y_SORTEOS: '/premios-y-sorteos',
    ACTIVIDADES: '/actividades',
    SALON_DE_LA_FAMA: '/salon-de-la-fama',
    CHOLLOS_FANTASY_BIWENGER: '/chollos-fantasy/biwenger',
    CHOLLOS_FANTASY_RELEVO: '/chollos-fantasy/fantasy-relevo',
    CHOLLOS_FANTASY_MARCA: '/chollos-fantasy/fantasy-marca',
    ONCE_TIPO_ADMIN: '/administrador/once-tipo',
    QUEDADA_FANTASY: '/quedada-fantasy',
    CALENDARIO_ADMIN: '/administrador/calendario-admin',
    LANZADORES_PENALTIS: '/lanzadores-de-penaltis',
    COMPARTIR_PLANTILLA: '/mis-plantillas-fantasy/compartir',
    ADMINISTRADOR_PARTIDOS: '/administrador/administrador-partidos',
    ADMINISTRADOR_CONFIGURACIONES: '/administrador/configuraciones',
    TIER_LIST: '/tierlists',
    TIER_LIST_PUBLIC: '/tierlists/fantasy',
    TIER_LIST_ADMIN: '/tierlists/admin',
    EDIT_TIER_LIST: '/tierlists/editar',
    VISUALIZAR_TIER_LIST: '/tierlists/ver',
    DELETE_TIER_LIST: '/tierlists',
    NUEVA_TIER_LIST: '/tierlists/crear-nueva-tierlist',
    NUEVA_TIER_LIST_ADMIN: '/tierlists/crear-nueva-admin-tierlist',
    FANTASY_DAZN_FALLECIO: '/fantasy-relevo-fallecio',
    ORACULO_FANTASY: '/oraculo-fantasy',
    KIT_DIGITAL: '/kit-digital',
    SITIOS_RECOMENDADOS: '/sitios-recomendados',
    SUSCRIPCIONES: '/suscripciones',
    PAGO_EXITOSO: '/pago-exitoso',
    PAGO_CANCELADO: '/pago-cancelado',
    CREADORES_CONTENIDO: '/colaboradores/creadores-de-contenido',
    PUNTUACIONES_FANTASY: '/puntuaciones-la-liga-fantasy-jornada',
    PREPARADOR_JORNADA: '/preparador-jornada',
    NOVEDADES: '/novedades-analitica-fantasy',
    PREMIUM: '/premium',
    PREMIUM_ANALYSIS: '/premium/analysis',
    PREMIUM_ACTIVIDADES: '/premium/actividades',
    ADMINISTRADOR_ANALISIS_PARTIDO: '/administrador/analisis-partido',
    ANALISIS_POST_PARTIDO: '/premium/analisis-partido',
    JUGADORES_BIWENGER: (slug) => `/jugadores/${slug}/fantasy-biwenger`,
    JUGADORES_FANTASY: (slug) => `/jugadores/${slug}`,
    ACTA_ARBITRAL_PARTIDO: (id) => `/administrador/administrador-partidos/${id}`,
    SALDO_ARBITRAL_PARTIDOS: '/la-liga/tarjetas-amarillas',
    SALDO_ARBITRAL_PARTIDOS_ROJAS: '/la-liga/tarjetas-rojas',
    LA_PIZARRA_DE_DONQUI: '/creador-de-contenido/donquijote',
    CENTRO_INFORMACION: '/centro-de-informacion',
    CENTRO_INFORMACION_FEED: '/centro-de-informacion/feed',
    EQUIPOS_V2_NOTICIAS: (slug) => `/equipo/${slug}/noticias`,
    EQUIPOS_V2_CALENDARIO: (slug) => `/equipo/${slug}/calendario`,
    EQUIPOS_V2_ALINEACIONES: (slug) => `/equipo/${slug}`,
    EQUIPOS_V2_DATOS: (slug) => `/equipo/${slug}/datos`,
    CALENDARIO_DE_PARTIDOS: '/calendario-de-partidos',
    BUSCADOR_DE_JUGADORES: '/buscador-de-jugadores',
    GUIAS_FANTASY: '/guias-fantasy',
    GUIAS_FANTASY_FANTASY_LA_LIGA: '/guias-fantasy/la-liga-fantasy',
    GUIAS_FANTASY_FANTASY_BIWENGER: '/guias-fantasy/fantasy-biwenger',
    GUIAS_FANTASY_FANTASY_MARCA: '/guias-fantasy/fantasy-marca',
    GUIAS_FANTASY_FANTASY_MISTER: '/guias-fantasy/mister-fantasy',
    PREDICCION_PARTIDO: (slug) => `/partido/${slug}/prediccion-de-partido`,
    ONCE_TIPO: '/once-tipo',
    FICHAJES: '/fichajes',
    MERCADO_BIWENGER_TABLE: '/biwenger/mercado-de-jugadores',
    FICHAJES_EQUIPO: (slug) => `/equipo/${slug}/fichajes`,
    ESTADISTICAS_EQUIPO: (slug) => `/equipo/${slug}/estadisticas`,
    FANTASY_MARCA_MERCADO: '/fantasy-marca/mercado',
    FANTASY_KAOS_PIZARRA: '/fantasy-kaos/pizarra',
    FANTASY_KAOS_PRESIDENTES: '/fantasy-kaos/presidentes',
    FANTASY_KAOS_REGLAS: '/fantasy-kaos/reglas',
    FANTASY_KAOS_MANAGERS: '/fantasy-kaos/managers',
    FANTASY_KAOS_RANKING_DE_PRESIDENTES: '/fantasy-kaos/ranking-de-presidentes',
    FANTASY_KAOS_SORTEO: '/fantasy-kaos/sorteo',
    FANTASY_MARCA_MERCADO_EQUIPOS: '/fantasy-marca/mercado-equipos',
    FANTASY_MARCA_SUBIDAS_Y_BAJADAS: '/fantasy-marca/subidas-y-bajadas',
    PREDICCION_DE_MERCADO: '/fantasy-la-liga/prediccion-de-mercado',
    CHOLLOS_FANTASY_MISTER: '/chollos-fantasy/mister-fantasy',
    MISTER_FANTASY_MERCADO: '/mister-fantasy/mercado',
    MISTER_FANTASY_MERCADO_EQUIPOS: '/mister-fantasy/mercado-equipos',
    MISTER_FANTASY_SUBIDAS_Y_BAJADAS: '/mister-fantasy/subidas-y-bajadas',
    RULETA_FANTASY: '/ruleta-fantasy',
    RULETA_FANTASY_RANKING: '/ruleta-fantasy/ranking-por-aciertos',
    RULETA_FANTASY_RANKING_GLOBAL: '/ruleta-fantasy/ranking-global',
    BUZON_CIUDADANO: '/buzon',
    COLABORADOR_ARGAMBOY: '/creador-de-contenido/argamboy',
    COLABORADOR_TABOO: '/creador-de-contenido/taboo',
    PUNTUACIONES_BIWENGER_DIARIO_AS: '/puntuaciones-biwenger/diario-as',
    PUNTUACIONES_BIWENGER_SOFASCORE: '/puntuaciones-biwenger/sofascore',
    PUNTUACIONES_BIWENGER_STATS: '/puntuaciones-biwenger/stats',
    PUNTUACIONES_BIWENGER_SOCIAL: '/puntuaciones-biwenger/social',
    PUNTUACIONES_BIWENGER_CARRUSEL_DEPORTIVO: '/puntuaciones-biwenger/carrusel-deportivo',
    PUNTUACIONES_BIWENGER_PROMEDIO_DIARIO_AS_SOFASCORE: '/puntuaciones-biwenger/promedio-diario-as-sofascore',
    PUNTUACIONES_FANTASY_MARCA: '/puntuaciones-fantasy-marca',
    PUNTUACIONES_FANTASY_MISTER: '/puntuaciones-mister-fantasy',
    FAVORITOS: '/favoritos',
    FAVORITOS_NOTICIAS: '/favoritos/noticias',
    FAVORITOS_NOTICIAS_FLASH: '/favoritos/noticias-flash',
    FAVORITOS_FANTASY_INFO: '/favoritos/fantasy-la-liga',
    FAVORITOS_MISTER_FANTASY: '/favoritos/mister-fantasy',
    FAVORITOS_FANTASY_MARCA: '/favoritos/fantasy-marca',
    FAVORITOS_BIWENGER_DIARIO_AS: '/favoritos/biwenger/diario-as',
    FAVORITOS_BIWENGER_SOFASCORE: '/favoritos/biwenger/sofascore',
    FAVORITOS_BIWENGER_ESTADISTICAS: '/favoritos/biwenger/estadisticas',
    FAVORITOS_BIWENGER_DIARIO_AS_SOFASCORE: '/favoritos/biwenger/diario-as-sofascore',
    FAVORITOS_BIWENGER_SOCIAL: '/favoritos/biwenger/social',
    LOGS: '/administrador/logs',
    PUSH_NOTIFICATIONS: '/administrador/push-notifications',
    PREDICCIONES_FANTASY: '/predicciones-fantasy',
    PREDICCIONES_FANTASY_RANKING: '/predicciones-fantasy/ranking',
    PREDICCIONES_FANTASY_REGLAS: '/predicciones-fantasy/reglas',
    PRISMA_PUBLICACIONES: (slug) => `/prisma/noticia/${slug}`,
    PRISMA_CATEGORIA: (slug) => `/prisma/categoria/${slug}`,
    CREAR_RECOMENDACION: '/recomendaciones/crear',
    EDITAR_RECOMENDACION: (id) => `/recomendaciones/editar/${id}`,
    RECOMENDACIONES_ANALITICA_FANTASY: '/recomendaciones/analiticafantasy',
    VISUALIZAR_RECOMENDACION: (slug) => `/recomendaciones/visualizar/${slug}`,
    PRISMA_TERMINOS_Y_CONDICIONES: '/prisma/terminos-y-condiciones',
    PRISMA_POLITICA_DE_PRIVACIDAD: '/prisma/politica-de-privacidad',
    PRISMA_CONTACTO: '/prisma/contacto',
    SOPORTE: '/analitica/soporte',
    PRISMA_EN: '/en/prisma',
    PRISMA: '/prisma',
    CHAT: '/chat',
    APUESTAS_DEPORTIVAS_WEB: (slug) => `/apuestas-deportivas/web/${slug}`,
    POSTS: '/post',
    POST_CREAR: '/post/create',
    POST_EDITAR: (id) => `/post/${id}/edit`,
    ESTADISTICAS_FANTASY_MARCA: '/estadisticas-fantasy/fantasy-marca',
    ESTADISTICAS_FANTASY_MARCA_ANALYTICS: '/estadisticas-fantasy/fantasy-marca/analytics',
    ESTADISTICAS_MISTER_FANTASY: '/estadisticas-fantasy/mister-fantasy',
    ESTADISTICAS_MISTER_FANTASY_ANALYTICS: '/estadisticas-fantasy/mister-fantasy/analytics',
};
